import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgCh48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "Switzerland",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e7e7e7",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#de2910",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.91 10.47H13.5V7.06h-3.15v3.41H6.94v3h3.41v3.41h3.15V13.5h3.41z"
}));

export { SvgCh48Rounded as default };
//# sourceMappingURL=Ch48Rounded.js.map
